// import React, { useState, useEffect } from 'react';
// import { useParams } from 'react-router-dom';
// import { getGuestById } from '../../helpers/api.ts';
// import {
//   Container,
//   Card,
//   CardBody,
//   Row,
//   Col,
//   Table,
//   Spinner
// } from 'reactstrap';
// import Breadcrumbs from '../../components/Common/Breadcrumb.js';

// const GuestDetails = () => {
//   const { id } = useParams();
//   const [guestData, setGuestData] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchGuestDetails();
//   }, [id]);

//   const fetchGuestDetails = async () => {
//     try {
//       const response = await getGuestById(id, {});
//       setGuestData(response.data);
//     } catch (error) {
//       console.error('Error fetching guest details:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="text-center" style={{ marginTop: '350px' }}>
//         <Spinner color="primary" />
//       </div>
//     );
//   }

//   return (
//     <Container fluid className="page-content">
//       <Breadcrumbs title="Guest Details" breadcrumbItem="Guest Information" />
      
//       {guestData && (
//         <>
//           <Card className="mb-4">
//             <CardBody>
//               <h4 className="mb-4">Guest Information</h4>
//               <Row>
//                 <Col md={3}>
//                   <p className="mb-2"><strong>Name:</strong> {guestData.guest_details.name}</p>
//                 </Col>
//                 <Col md={3}>
//                   <p className="mb-2"><strong>Mobile:</strong> {guestData.guest_details.mobile}</p>
//                 </Col>
//                 <Col md={3}>
//                   <p className="mb-2"><strong>Email:</strong> {guestData.guest_details.email}</p>
//                 </Col>
//                 <Col md={3}>
//                   <p className="mb-2"><strong>Address:</strong> {guestData.guest_details.address}</p>
//                 </Col>
//               </Row>
//             </CardBody>
//           </Card>

//           <Card className="mb-4">
//             <CardBody>
//               <h4 className="mb-4">Billing Summary</h4>
//               <Row>
//                 <Col md={3}>
//                   <p className="mb-2"><strong>Room Charges:</strong> ₹{guestData.billing.summary.room_charges}</p>
//                 </Col>
//                 <Col md={3}>
//                   <p className="mb-2"><strong>Spa Charges:</strong> ₹{guestData.billing.summary.spa_charges}</p>
//                 </Col>
//                 <Col md={3}>
//                   <p className="mb-2"><strong>Restaurant Charges:</strong> ₹{guestData.billing.summary.restaurant_charges}</p>
//                 </Col>
//                 <Col md={3}>
//                   {/* <p className="mb-2"><strong>GST:</strong> ₹{guestData.billing.summary.gst}</p> */}
//                 </Col>
//                 <Col md={12}>
//                   <h5 className="mt-3">Total Amount: ₹{guestData.billing.summary.total_amount}</h5>
//                 </Col>
//               </Row>
//             </CardBody>
//           </Card>

//           <Card className="mb-4">
//             <CardBody>
//               <h4 className="mb-4">Room Booking Details</h4>
//               <Table responsive bordered>
//                 <thead>
//                   <tr>
//                     <th>Room Number</th>
//                     <th>Room Type</th>
//                     <th>AC Type</th>
//                     <th>Check In</th>
//                     <th>Check Out</th>
//                     <th>Nights</th>
//                     <th>Rate/Night</th>
//                     <th>Food Charges</th>
//                     <th>Total Amount</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {guestData.billing.breakdown.room_details.map((room, index) => (
//                     <tr key={index}>
//                       <td>{room.room_number}</td>
//                       <td>{room.room_type}</td>
//                       <td>{room.ac_type}</td>
//                       <td>{room.check_in}</td>
//                       <td>{room.check_out}</td>
//                       <td>{room.nights}</td>
//                       <td>₹{room.rate_per_night}</td>
//                       <td>₹{room.food_charges}</td>
//                       <td>₹{room.amount}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </CardBody>
//           </Card>

//           <Card className="mb-4">
//             <CardBody>
//               <h4 className="mb-4">Spa Services</h4>
//               <Table responsive bordered>
//                 <thead>
//                   <tr>
//                     <th>Date</th>
//                     <th>service</th>
//                     <th>Therapist</th>
//                     <th>Status</th>
//                     <th>Amount</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {guestData.billing.breakdown.spa_services.map((service, index) => (
//                     <tr key={index}>
//                       <td>{new Date(service.date).toLocaleDateString()}</td>
//                       <td>{service.service}</td>
//                       <td>{service.therapist}</td>
//                       <td>{service.status}</td>
//                       <td>₹{service.amount}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </CardBody>
//           </Card>

//           <Card>
//             <CardBody>
//               <h4 className="mb-4">Restaurant Orders</h4>
//               <Table responsive bordered>
//                 <thead>
//                   <tr>
//                     <th>Item</th>
//                     <th>Category</th>
//                     <th>Quantity</th>
//                     <th>Rate</th>
//                     <th>Amount</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {guestData.billing.breakdown.restaurant_orders.map((order, index) => (
//                     <tr key={index}>
//                       <td>{order.item}</td>
//                       <td>{order.category}</td>
//                       <td>{order.quantity}</td>
//                       <td>₹{order.rate}</td>
//                       <td>₹{order.amount}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </CardBody>
//           </Card>
//         </>
//       )}
//     </Container>
//   );
// };

// export default GuestDetails;


import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getGuestById } from '../../helpers/api.ts';
import {
  Container,
  Card,
  CardBody,
  Row,
  Col,
  Table,
  Spinner,
  Pagination,
  PaginationItem,
  PaginationLink,
  Button
} from 'reactstrap';
import Breadcrumbs from '../../components/Common/Breadcrumb.js';
import HotelInvoice from '../Hotels/HotelBill.js';
import moment from 'moment';

const ITEMS_PER_PAGE = 3;

const PaginationComponent = ({ currentPage, totalPages, onPageChange }) => (
  <Pagination className="mt-3">
    <PaginationItem disabled={currentPage === 1}>
      <PaginationLink previous onClick={() => onPageChange(currentPage - 1)} />
    </PaginationItem>
    {[...Array(totalPages)].map((_, i) => (
      <PaginationItem active={i + 1 === currentPage} key={i}>
        <PaginationLink onClick={() => onPageChange(i + 1)}>
          {i + 1}
        </PaginationLink>
      </PaginationItem>
    ))}
    <PaginationItem disabled={currentPage === totalPages}>
      <PaginationLink next onClick={() => onPageChange(currentPage + 1)} />
    </PaginationItem>
  </Pagination>
);

// A guest with no stays or bills may come back without billing sections; fill the
// gaps so the page opens instead of crashing.
const withGuestDefaults = (data) => {
  const d = data || {};
  const billing = d.billing || {};
  const breakdown = billing.breakdown || {};
  return {
    ...d,
    guest_details: d.guest_details || {},
    billing: {
      ...billing,
      summary: billing.summary || {},
      breakdown: {
        ...breakdown,
        room_details: breakdown.room_details || [],
        spa_services: breakdown.spa_services || [],
        restaurant_orders: breakdown.restaurant_orders || [],
      },
    },
  };
};

const GuestDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [guestData, setGuestData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [roomPage, setRoomPage] = useState(1);
  const [spaPage, setSpaPage] = useState(1);
  const [restaurantPage, setRestaurantPage] = useState(1);

  useEffect(() => {
    fetchGuestDetails();
  }, [id]);

  const fetchGuestDetails = async () => {
    try {
      const response = await getGuestById(id, {});
      setGuestData(withGuestDefaults(response.data));
    } catch (error) {
      console.error('Error fetching guest details:', error);
    } finally {
      setLoading(false);
    }
  };

  const getPaginatedData = (data, page) => {
    const startIndex = (page - 1) * ITEMS_PER_PAGE;
    return data.slice(startIndex, startIndex + ITEMS_PER_PAGE);
  };

  const getTotalPages = (data) => Math.ceil(data.length / ITEMS_PER_PAGE);

  if (loading) {
    return (
      <div className="text-center" style={{ marginTop: '350px' }}>
        <Spinner color="primary" />
      </div>
    );
  }

  return (
    <Container fluid className="page-content">
      <Breadcrumbs title="Guest Details" breadcrumbItem="Guest Information" />
      
      <div className="d-flex justify-content-end mb-3">
        <Button color="secondary" onClick={() => navigate("/guest")} className="w-100 w-md-auto">
          Back
        </Button>
      </div>

      {guestData && (
        <>
          <Card className="mb-4">
            <CardBody>
              <h4 className="mb-4">Guest Information</h4>
              {/* <HotelInvoice/> */}

              <Row>
                <Col md={3}>
                  <p className="mb-2"><strong>Name:</strong> {guestData.guest_details.name}</p>
                </Col>
                <Col md={3}>
                  <p className="mb-2"><strong>Mobile:</strong> {guestData.guest_details.mobile}</p>
                </Col>
                <Col md={3}>
                  <p className="mb-2"><strong>Email:</strong> {guestData.guest_details.email}</p>
                </Col>
                <Col md={3}>
                  <p className="mb-2"><strong>Address:</strong> {guestData.guest_details.address}</p>
                </Col>
              </Row>
            </CardBody>
          </Card>

          <Card className="mb-4">
            <CardBody>
              <h4 className="mb-4">Billing Summary</h4>
              <Row>
                <Col md={3}>
                  <p className="mb-2"><strong>Room Charges:</strong> ₹{guestData.billing.summary.room_charges}</p>
                </Col>
                <Col md={3}>
                  <p className="mb-2"><strong>Spa Charges:</strong> ₹{guestData.billing.summary.spa_charges}</p>
                </Col>
                <Col md={3}>
                  <p className="mb-2"><strong>Restaurant Charges:</strong> ₹{guestData.billing.summary.restaurant_charges}</p>
                </Col>
                <Col md={3}>
                  <p className="mb-2"><strong>GST:</strong> ₹{guestData.billing.summary.gst}</p>
                </Col>
                <Col md={12}>
                  <h5 className="mt-3">Total Amount: ₹{guestData.billing.summary.total_amount}</h5>
                </Col>
              </Row>
            </CardBody>
          </Card>

          <Card className="mb-4">
            <CardBody>
              <h4 className="mb-4">Room Booking Details</h4>
              <Table responsive bordered>
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Room Number</th>
                    <th>Room Type</th>
                    <th>AC Type</th>
                    <th>Check In</th>
                    <th>Check Out</th>
                    <th>Nights</th>
                    <th>Rate/Night</th>
                    <th>Food Charges</th>
                    <th>Total Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {getPaginatedData(guestData.billing.breakdown.room_details, roomPage).map((room, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{room.room_number}</td>
                      <td>{room.room_type}</td>
                      <td>{room.ac_type}</td>
                      <td>{new moment(room.check_in).format('DD-MM-YYYY')}</td>
                      <td>{new moment(room.check_out).format('DD-MM-YYYY')}</td>
                      <td>{room.nights}</td>
                      <td>₹{room.rate_per_night}</td>
                      <td>₹{room.food_charges}</td>
                      <td>₹{room.amount}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <PaginationComponent 
                currentPage={roomPage}
                totalPages={getTotalPages(guestData.billing.breakdown.room_details)}
                onPageChange={setRoomPage}
              />
            </CardBody>
          </Card>

          <Card className="mb-4">
            <CardBody>
              <h4 className="mb-4">Spa Services</h4>
              <Table responsive bordered>
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Date</th>
                    <th>Therapist</th>
                    <th>Service</th>
                    <th>Amount</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {getPaginatedData(guestData.billing.breakdown.spa_services, spaPage).map((service, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{new moment(service.date).format('DD-MM-YYYY')}</td>
                      <td>{service.therapist}</td>
                      <td>{service.service}</td>
                      <td>₹{service.amount}</td>
                      <td>{service.status}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <PaginationComponent 
                currentPage={spaPage}
                totalPages={getTotalPages(guestData.billing.breakdown.spa_services)}
                onPageChange={setSpaPage}
              />
            </CardBody>
          </Card>

          <Card>
            <CardBody>
              <h4 className="mb-4">Restaurant Orders</h4>
              <Table responsive bordered>
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Item</th>
                    <th>Category</th>
                    <th>Quantity</th>
                    <th>Rate</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
  {getPaginatedData(guestData.billing.breakdown.restaurant_orders, restaurantPage).map((order, index) => (
    <tr key={index}>
      <td>{index + 1}</td>
      <td>{order.item}</td>
      <td>{order.category}</td>
      <td>{order.quantity}</td>
      <td>₹{order.rate}</td>
      <td>₹{order.amount}</td>
    </tr>
  ))}
</tbody>
              </Table>
              <PaginationComponent 
                currentPage={restaurantPage}
                totalPages={getTotalPages(guestData.billing.breakdown.restaurant_orders)}
                onPageChange={setRestaurantPage}
              />
            </CardBody>
          </Card>
        </>
      )}
    </Container>
  );
};

export default GuestDetails;
